import React from 'react';
import { observer } from 'mobx-react-lite';
import styles from './QrOriginalData.module.css';
import Popup from '../../../../../../../../components/common-components/pop-up/Popup';
import { useStore } from '../../../../../../../../hooks/useStore';

interface QrOriginalDataProps {
  data: string;
}

const QrOriginalData: React.FC<QrOriginalDataProps> = ({ data }) => {
  const { popupStore } = useStore();
  const parseTableData = (htmlString: string) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const table = doc.querySelector('#tableContent');

    if (!table) return [];

    const rows = Array.from(table.querySelectorAll('tr'));
    return rows
      .map(row => {
        const cells = Array.from(row.querySelectorAll('td'));
        return cells.map(cell => cell.textContent?.trim() || '');
      })
      .filter(row => row.length > 1 && row[0] !== ''); // Boş satırları ve tek hücreli satırları filtrele
  };

  const tableData = parseTableData(data);

  return (
    <Popup
      isOpen={popupStore.isQrCodeOriginalDataOpen}
      onClose={() => popupStore.setIsQrCodeOriginalDataOpen(false)}
      title="QR Kod Orijinal Veri"
    >
      <div className={styles.container}>
        <div className={styles.tableWrapper}>
          <table className={styles.dataTable}>
            <tbody>
              {tableData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {row.map((cell, cellIndex) => (
                    <td
                      key={`${rowIndex}-${cellIndex}`}
                      className={cellIndex === 0 ? styles.labelCell : styles.valueCell}
                    >
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Popup>
  );
};

export default observer(QrOriginalData);
